import { Route, Routes } from 'react-router-dom';
import PrivateRoute from '../config/PrivateRoute';
import AppLayout from '../Layout/AppLayout';
import Register from '../pages/Admin/Register';
import Stores from '../pages/Admin/Stores';
import UserRoleAccess from '../pages/Admin/UserRoleAccess';
import SupplyBilling from '../pages/Billing/SupplyBilling';
import BOLApprovals from '../pages/BOL/Approvals';
import BillOfLading from '../pages/BOL/BillOfLading';
import BolList from '../pages/BOL/BolList';
import SuperAdminBOL from '../pages/BOL/SuperAdminBOL';
import TodayList from '../pages/BOL/TodayList';
import DashboardPage from '../pages/DashboardPage';
import LoginPage from '../pages/Login';
import NotFound from '../pages/NotFound';
import ProfilePage from '../pages/ProfilePage';
import ScannerPage from '../pages/Trailer/Scanner';
import TrailerProducts from '../pages/Trailer/TrailerProducts';
import YardManagementPage from '../pages/Trailer/yard-management';
import ShuntingJobs from '../pages/BOL/ShuntingJobs';

export default function AppRoutes() {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route element={<PrivateRoute />}>
                <Route element={<AppLayout />}>
                    <Route path="/" element={<TodayList />} />
                    <Route path="/profile" element={<ProfilePage />} />
                    <Route path="/dashboard" element={<DashboardPage />} />

                    {/* Trailer Routes */}
                    <Route path="/trailer" element={<TrailerProducts />} />
                    <Route path="/scanner" element={<ScannerPage />} />
                    <Route path="/yard" element={<YardManagementPage />} />

                    {/* BOL Routes */}
                    <Route path="/bol" element={<BillOfLading />} />
                    <Route path="/superAdminBol" element={<SuperAdminBOL />} />
                    <Route path="/bolList" element={<BolList />} />
                    <Route path="/approvals" element={<BOLApprovals />} />
                    <Route path="/shunting" element={<ShuntingJobs />} />

                    {/* Billing Routes */}
                    <Route path="/supplyBilling" element={<SupplyBilling />} />

                    {/* Admin Routes */}
                    <Route path="/register" element={<Register />} />
                    <Route path="/users" element={<UserRoleAccess />} />
                    <Route path="/stores" element={<Stores />} />
                </Route>
            </Route>

            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}